<template>
  <b-modal title="Relatório de Despesas de Veículo" v-model="show" size="xl">
    <div id="relatorioDeVeiculo">
      <b-container fluid>
        <!-- :::::::::::::::::::::::::::: HEADER DO RELATORIO DE VEÍCULO :::::::::::::::::::::::::::: -->
        <b-row class="mt-2">
          <b-col cols="2">
            <img class="m-2" :src="require('/static/images/logo_sgcq.png')" aria-label="Logomarca do SGCQ" width="160" />
          </b-col>
          <b-col cols="10">
            <h3>NEW ENERGY TECH EIRELI</h3>
            <h6>Serviços Técnicos de Consultória, Projeto, Fabricação, Inspeção de Equipamentos.</h6>
            <h6>BR 304 - Km 50,5 - Zona Rural</h6>
            <h6>Fone: (84) 9 9604-4935 / (84) 9 8740-0525</h6>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="5">
            <b-form-group label="Descrição:" label-for="descricao" label-cols="3" class="m-1">
              <b-form-input id="descricao" v-model="veiculo.descricao" />
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label="Cor:" label-for="cor" label-cols="2" class="m-1">
              <b-form-input id="cor" v-model="veiculo.cor" />
            </b-form-group>
          </b-col>

          <b-col cols="4" class="m-0">
            <b-form-group label="Início:" label-for="inicio" label-cols="2" class="m-1">
              <b-form-datepicker
                id="inicio"
                v-model="periodo.inicio"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
              ></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col cols="5" class="m-0">
            <b-form-group label="Placa:" label-for="placa" label-cols="3" class="m-1">
              <b-form-input id="placa" v-model="veiculo.placa" />
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label="Ano:" label-for="ano" label-cols="2" class="m-1">
              <b-form-input id="ano" v-model="veiculo.ano" />
            </b-form-group>
          </b-col>

          <b-col cols="4" class="m-0">
            <b-form-group label="Final:" label-for="final" label-cols="2" class="m-1">
              <b-form-datepicker
                id="final"
                v-model="periodo.final"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- :::::::::::::::::::::::::::: DESPESAS DAS MANUTENÇÕES :::::::::::::::::::::::::::: -->
        <hr />
        <b-row class="mt-2">
          <b-col cols="12" class="text-center">
            <h4><strong>DESPESAS DAS MANUTENÇÕES</strong></h4>
          </b-col>
        </b-row>

        <b-table bordered small head-variant="light" :items="getPeriodManutencoes(periodo)" :fields="fields.manutencaoRelatorio">
          <template #cell(data)="data">
            <div>
              <p class="pt-0 pb-0">
                {{ moment(data.item.data).format("DD/MM/YYYY") }}
              </p>
            </div>
          </template>

          <template #cell(valor)="data">
            <div>
              <p>{{ formatter.format(data.item.valor) }}</p>
            </div>
          </template>
        </b-table>

        <b-row>
          <b-col offset="6" cols="6">
            <h5 class="text-right">
              <strong>Total: {{ formatter.format(getTotalManutencoes) }}</strong>
            </h5>
          </b-col>
        </b-row>

        <!-- :::::::::::::::::::::::::::: DESPESAS DAS ABASTECIMENTOS :::::::::::::::::::::::::::: -->
        <hr />
        <b-row class="mt-2">
          <b-col cols="12" class="text-center">
            <h4><strong>DESPESAS COM ABASTECIMENTOS</strong></h4>
          </b-col>
        </b-row>

        <b-table
          bordered
          small
          head-variant="light"
          :items="getPeriodAbastecimentos(periodo)"
          :fields="fields.abastecimentorRelatorio"
        >
          <template #cell(data)="data">
            <div>
              <p class="pt-0 pb-0">
                {{ moment(data.item.data).format("DD/MM/YYYY") }}
              </p>
            </div>
          </template>

          <template #cell(valor)="data">
            <div>
              <p>{{ formatter.format(data.item.valor) }}</p>
            </div>
          </template>
        </b-table>

        <b-row>
          <b-col offset="6" cols="6">
            <h5 class="text-right">
              <strong>Total: {{ formatter.format(getTotalAbastecimentos) }}</strong>
            </h5>
          </b-col>
        </b-row>

        <!-- :::::::::::::::::::::::::::: RODAPE DO PROTOCOLO :::::::::::::::::::::::::::: -->
        <hr />
        <b-row class="mt-2">
          <b-col cols="12" class="text-center">
            <div class="borda-redonda">
              <!-- :::::::::::::::::::::::::::: TOTAL AQUI :::::::::::::::::::::::::::: -->
              <b-row>
                <b-col offset="7" cols="5">
                  <h5 class="text-right">
                    <strong>Total das Despesas do Veículo: {{ formatter.format(getTotal) }}</strong>
                  </h5>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <template #modal-footer>
      <b-row class="pb-1">
        <b-col cols="4" class="p-0"> </b-col>
        <b-col cols="8" class="p-0"> </b-col>
      </b-row>

      <b-button variant="primary" v-print="'#relatorioDeVeiculo'">Imprimir</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { VMoney } from "v-money";
import { useVeiculoStore } from "@/stores/VeiculoStore";
import TableFields from "@/tools/TableFields";
import Veiculo from "@/models/Veiculo";

export default {
  name: "ModalDeRelatorioDeVeiculo",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      veiculo: new Veiculo(0, "Novo Transporte", "", "", "", "", ""),
      periodo: { inicio: new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000), final: new Date() },
      formatter: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }),
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },

  directives: { money: VMoney },

  methods: {
    update() {
      this.veiculoStore.LISTAR_MANUTENCOES(this.veiculo.id);
      this.veiculoStore.LISTAR_ABASTECIMENTOS(this.veiculo.id);
    },

    call(veiculo) {
      this.show = !this.show;
      this.veiculo = veiculo;
      this.update();
    },
  },

  setup() {
    const store = useSgcqStore();
    const veiculoStore = useVeiculoStore();
    const { getPeriodManutencoes } = storeToRefs(veiculoStore);
    const { getPeriodAbastecimentos } = storeToRefs(veiculoStore);
    const { getTotalManutencoes } = storeToRefs(veiculoStore);
    const { getTotalAbastecimentos } = storeToRefs(veiculoStore);
    const { getTotal } = storeToRefs(veiculoStore);

    return {
      store,
      veiculoStore,
      getPeriodManutencoes,
      getPeriodAbastecimentos,
      getTotalManutencoes,
      getTotalAbastecimentos,
      getTotal,
    };
  },
};
</script>

<style lang="scss" scoped>
.emlinha {
  display: inline-flexbox;
}
.borda-redonda {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 0.6rem;
}
</style>
